// Search that reads the way people type: case, accents and the Greek tonos don't matter, and a final
// sigma is a sigma. So "νικος" finds "Νίκος", "lefevre" finds "Lefèvre" and "ΟΙΚΟΝΟΜΟΥ" finds
// "Οικονόμου". Fold the query once with fold(), then test each value with hasText().

/** text folded for matching: accents stripped (NFD, then the combining marks dropped), lower case,
 *  and ς as σ. */
export function fold(v: unknown): string {
  if (v == null || typeof v === 'boolean') return '';
  return String(v).normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/ς/g, 'σ');
}

/** whether any of the values contains the query. `query` must already be folded (fold(q.trim()));
 *  an empty query matches everything. Ticks (booleans) never match text. */
export function hasText(query: string, ...values: unknown[]): boolean {
  return !query || values.some((v) => fold(v).includes(query));
}
